import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class SimpleHorizontalHeadersTable extends React.Component {
  render () {
    const classes = classNames({
      "table": true,
      "simple-horizontal-headers-table": true
    });

    const rows = this.props.data.map(([header, value], i) => {
      return (
        <tr key={i}>
          <td>{header}</td>
          <td>{value}</td>
        </tr>
      );
    });

    return (
      <table className={classes}>
        <tbody>
          {rows}
        </tbody>
      </table>
    );
  }
}

SimpleHorizontalHeadersTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default SimpleHorizontalHeadersTable;
